module.exports = __webpack_public_path__ + "static/media/ilustracion1.0fca63a8.png";